// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2NLLB","alert":"SettungsInbox_alert__3Og0S"};